import React,{useEffect} from 'react'
import { Link, useNavigate } from 'react-router-dom'
import {URL} from '../Helper/helper';
import './UserComponent.css'

function UserComponent() {
  
  const navigate = useNavigate()
  const user_info = JSON.parse(localStorage.getItem('user'))

  useEffect(() =>{
    if(!user_info){
        navigate('/')
    }
    async function invokeUsers(){

      const user_reservations = await fetch(`${URL}`+'/bookings')
      const booking_response = await user_reservations.json()
      let cust_booking_response = booking_response.filter(b => b.userName === user_info.userName);
      console.log('Customers :',cust_booking_response)
      localStorage.setItem('userBookings',JSON.stringify(cust_booking_response))
    }

    invokeUsers()

  },[])

  const navigateBookings = () =>{
      navigate('/bookings')
  }
  const navigateManageBookings = () =>{
    navigate('/adminbook')
}
  const navigatePBookings = () =>{
    navigate('/mpermbook')
  }
  const navigateAddTrainer = () =>{
    navigate('/addtrainer')
  }
  const navigateAddTermDates = () => {
      navigate('/addterm')
  }
  const navigateAddServices = () => {
    navigate('/addservice')
  }
  const navigateAddSquad = () => {
    navigate('/addsquad')
  }
  const navigateAddSquadInfo = () => {
    navigate('/addsquadinfo')
  }
  const navigateAddDisclaimer = () => {
    navigate('/add-disclaimer')
  }
  const navigateAddGallery = () => {
    navigate('/addgallery')
  }
  const navigateAddHoliday = () => {
    navigate('/holidays')
  }
  const navigateFailedBookings = () => {
    navigate('/failed-bookings')
  }
  const navigateDeletedBookings = () => {
    navigate('/deleted-bookings')
  }


  return (
    <div className='dashboard-page'>
      <div className="container admin-container">
        {/* Dashboard Header */}
        <div className="row mt-5">
          <div className="col-md-12 col-sm-12">
            <div className="dashboard-header d-flex justify-content-between align-items-center mb-4">
              <div>
                <h3 className="mb-1">
                  <i className="fa fa-dashboard text-warning me-2"></i>
                  {user_info?.isAdmin ? 'Admin Dashboard' : 'Manager Dashboard'}
                </h3>
                <p className="text-muted">Welcome back, {user_info?.firstName || 'User'}! Manage your badminton operations</p>
              </div>
              <div className="dashboard-actions">
                <div className="user-info-badge">
                  <i className="fa fa-user-circle fa-2x text-primary me-2"></i>
                  <div className="user-details">
                    <small className="user-name">{user_info?.firstName} {user_info?.lastName}</small>
                    <small className="user-role">{user_info?.isAdmin ? 'Administrator' : 'Manager'}</small>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* All Dashboard Actions */}
        <div className="row mb-4">
          <div className="col-12">
            <div className="dashboard-section">
              <div className="section-header">
                <h5 className="section-title">
                  <i className="fa fa-th-large text-primary me-2"></i>
                  Dashboard Actions
                </h5>
                <p className="section-subtitle">Access all available features and management tools</p>
              </div>
              <div className="dashboard-buttons">
                {/* Core Booking Operations */}
                <button type='button' 
                  onClick={navigateBookings}
                  className='dashboard-btn primary'>
                  <i className="fa fa-plus-circle me-2"></i>
                  <span>New Booking</span>
                </button>
                <button type='button' 
                  onClick={navigateManageBookings}
                  className='dashboard-btn secondary'>
                  <i className="fa fa-cog me-2"></i>
                  <span>Manage Bookings</span>
                </button>
                <button type='button' 
                  onClick={navigateFailedBookings}
                  className='dashboard-btn warning'>
                  <i className="fa fa-exclamation-triangle me-2"></i>
                  <span>Failed Bookings</span>
                </button>
                <button type='button' 
                  onClick={navigateDeletedBookings}
                  className='dashboard-btn danger'>
                  <i className="fa fa-trash me-2"></i>
                  <span>Deleted Bookings</span>
                </button>

                {/* Admin Only Buttons */}
                {user_info?.isAdmin && (
                  <>
                    <button type='button' 
                      onClick={navigatePBookings}
                      className='dashboard-btn success'>
                      <i className="fa fa-calendar-plus me-2"></i>
                      <span>Permanent Bookings</span>
                    </button>
                    <button type='button' 
                      onClick={navigateAddTrainer}
                      className='dashboard-btn info'>
                      <i className="fa fa-users me-2"></i>
                      <span>Manage Trainers</span>
                    </button>
                    <button type='button' 
                      onClick={navigateAddTermDates}
                      className='dashboard-btn outline-primary'>
                      <i className="fa fa-calendar me-2"></i>
                      <span>Term Dates</span>
                    </button>
                    <button type='button' 
                      onClick={navigateAddServices}
                      className='dashboard-btn outline-success'>
                      <i className="fa fa-star me-2"></i>
                      <span>Services</span>
                    </button>
                    <button type='button' 
                      onClick={navigateAddSquad}
                      className='dashboard-btn outline-info'>
                      <i className="fa fa-group me-2"></i>
                      <span>Squad</span>
                    </button>
                    <button type='button' 
                      onClick={navigateAddSquadInfo}
                      className='dashboard-btn outline-warning'>
                      <i className="fa fa-info-circle me-2"></i>
                      <span>Squad Info</span>
                    </button>
                    <button type='button' 
                      onClick={navigateAddDisclaimer}
                      className='dashboard-btn outline-secondary'>
                      <i className="fa fa-file-text me-2"></i>
                      <span>Disclaimer</span>
                    </button>
                    <button type='button' 
                      onClick={navigateAddGallery}
                      className='dashboard-btn outline-info'>
                      <i className="fa fa-images me-2"></i>
                      <span>Gallery</span>
                    </button>
                    <button type='button' 
                      onClick={navigateAddHoliday}
                      className='dashboard-btn outline-danger'>
                      <i className="fa fa-calendar-times me-2"></i>
                      <span>Holidays</span>
                    </button>
                  </>
                )}
              </div>
            </div>
          </div>
        </div>

        {/* Manager Notice */}
        {!user_info?.isAdmin && (
          <div className="row">
            <div className="col-12">
              <div className="manager-notice">
                <div className="notice-content">
                  <i className="fa fa-info-circle fa-2x text-info me-3"></i>
                  <div>
                    <h6 className="notice-title">Manager Access</h6>
                    <p className="notice-text">You have manager-level access. Contact your administrator for additional permissions.</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  )
}

export default UserComponent